module.exports = __webpack_public_path__ + "img/04.dd731f4f.png";